// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-resume-container {
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 0% 6em;
    gap: 0% 6em;
    width: 100%;
    margin: auto;
    padding: 0 48px;
}

.report-resume-general-summary-title{
    margin-bottom: 24px;
    /* margin-left: var(--space-x3); */
}

.report-resume-left-col{
    justify-self: start;
}

.report-resume-right-col{
    justify-self: start;
}

.report-resume-item-text {
    padding-bottom: var(--space);
    width: auto;
}

.report-resume-item-text .baloa-table {
    color: var(--primary-dark-color);
}

.report-resume-item-text .baloa-names {
    color: var(--primary-very-dark-color);
}

.report-resume-item-text-icon {
    display: flex;
}

.report-resume-item-text-icon p{
    margin-right: 5px;
}



/* .tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tiptext {
    visibility: hidden;
    padding: 18px 32px;
    background: #fff;
    position: relative;
    min-width: 150px;
    max-width: 180px;
    border-radius: 5px;
    text-align: center;
    filter: drop-shadow(0 3px 5px #ccc);
    line-height: 1.5;
}
.tooltip .tiptext:after {
    content: "";
    position: absolute;
    bottom: 29px;
    left: 50%;
    margin-left: -44px;
    width: 17px;
    height: 18px;
    background: white;
    transform: rotate(45deg);
}
.tooltip:hover .tiptext {
    visibility: visible;
}

.tooltip.bottom .tiptext{
    margin-left: -26px;
    top: 150%;
    left: 50%;
}
.tooltip.bottom .tiptext::after{
    border-color: transparent transparent #2E2E2E transparent;
} */

.report-resume-general-summary__service-msg {
    padding: 10px;
    border-radius: 4px;
    background: var(--new-informative-banner-bg-color);
    display: flex;
    gap: 8px;
    margin-bottom: 24px;
}

.report-resume-general-summary__service-msg .baloa-username{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.report-resume-general-summary__service-msg .hubicon-info::before{
    font-size: 22px;
    color: #1D5CC9;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-general-summay/TournamentGeneralSummaryComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAuCG;;AAEH;IACI,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB","sourcesContent":[".report-resume-container {\n    display: grid;\n    grid-auto-rows: 1fr;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n    grid-gap: 0% 6em;\n    gap: 0% 6em;\n    width: 100%;\n    margin: auto;\n    padding: 0 48px;\n}\n\n.report-resume-general-summary-title{\n    margin-bottom: 24px;\n    /* margin-left: var(--space-x3); */\n}\n\n.report-resume-left-col{\n    justify-self: start;\n}\n\n.report-resume-right-col{\n    justify-self: start;\n}\n\n.report-resume-item-text {\n    padding-bottom: var(--space);\n    width: auto;\n}\n\n.report-resume-item-text .baloa-table {\n    color: var(--primary-dark-color);\n}\n\n.report-resume-item-text .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.report-resume-item-text-icon {\n    display: flex;\n}\n\n.report-resume-item-text-icon p{\n    margin-right: 5px;\n}\n\n\n\n/* .tooltip {\n    position: relative;\n    display: inline-block;\n}\n\n.tooltip .tiptext {\n    visibility: hidden;\n    padding: 18px 32px;\n    background: #fff;\n    position: relative;\n    min-width: 150px;\n    max-width: 180px;\n    border-radius: 5px;\n    text-align: center;\n    filter: drop-shadow(0 3px 5px #ccc);\n    line-height: 1.5;\n}\n.tooltip .tiptext:after {\n    content: \"\";\n    position: absolute;\n    bottom: 29px;\n    left: 50%;\n    margin-left: -44px;\n    width: 17px;\n    height: 18px;\n    background: white;\n    transform: rotate(45deg);\n}\n.tooltip:hover .tiptext {\n    visibility: visible;\n}\n\n.tooltip.bottom .tiptext{\n    margin-left: -26px;\n    top: 150%;\n    left: 50%;\n}\n.tooltip.bottom .tiptext::after{\n    border-color: transparent transparent #2E2E2E transparent;\n} */\n\n.report-resume-general-summary__service-msg {\n    padding: 10px;\n    border-radius: 4px;\n    background: var(--new-informative-banner-bg-color);\n    display: flex;\n    gap: 8px;\n    margin-bottom: 24px;\n}\n\n.report-resume-general-summary__service-msg .baloa-username{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.report-resume-general-summary__service-msg .hubicon-info::before{\n    font-size: 22px;\n    color: #1D5CC9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
